import {
    MINI_PDP_ON_OPEN,
    MINI_PDP_ON_CLOSE,
    MINI_PDP_ON_MODE_CHANGE,
    SELECT_PRODUCT,
    MINI_PDP_PERSIST_ERROR,
    MINI_PDP_CLOSE_ERROR,
    MINI_PDP_OPEN_ERROR,
    MINI_PDP_ON_DYNAMIC_GALLERIES_OPEN,
    MINI_PDP_ON_DYNAMIC_GALLERIES_CLOSE,
    MINI_PDP_ON_SHOP_THE_IMAGE_OPEN,
    MINI_PDP_ON_SHOP_THE_IMAGE_CLOSE,
    MINI_PDP_ON_SHOP_THE_LOOK_OPEN,
    MINI_PDP_ON_SHOP_THE_LOOK_CLOSE,
    MINI_PDP_ON_STYLED_FOR_YOU_OPEN,
    MINI_PDP_ON_STYLED_FOR_YOU_CLOSE,
    MINI_PDP_ATC_FROM_STL,
    MINI_PDP_ON_SHOP_THE_SET_OPEN,
    MINI_PDP_ON_SHOP_THE_SET_CLOSE,
    MINI_PDP_ATC_FROM_STS,
    MINI_PDP_ATC_FROM_DG,
    MINI_PDP_ATC_FROM_STYLEDFORYOU,
    MINI_PDP_ATC_FROM_SHOP_THE_IMAGE,
} from '../actionTypes/MiniPDPActionTypes';
import { UPDATE_ITEM } from '../actionTypes/UpdateItemActionTypes';

export const updateItems = (payload) => ({
    type: UPDATE_ITEM,
    payload: {
        payload,
    },
});

export const miniPDPOnOpen = (payload) => ({
    type: MINI_PDP_ON_OPEN,
    payload,
});

export const miniPDPOnClose = () => ({
    type: MINI_PDP_ON_CLOSE,
});

export const miniPDPOnModeChange = (slide) => ({
    type: MINI_PDP_ON_MODE_CHANGE,
    payload: slide,
});

export const selectProduct = (payload) => ({
    type: SELECT_PRODUCT,
    payload,
});

export const persistError = () => ({
    type: MINI_PDP_PERSIST_ERROR,
});

export const miniPDPOpenError = () => ({
    type: MINI_PDP_OPEN_ERROR,
});

export const miniPDPCloseError = () => ({
    type: MINI_PDP_CLOSE_ERROR,
});

export const miniPDPOnDynamicGalleriesOpen = (itemId = '') => ({
    type: MINI_PDP_ON_DYNAMIC_GALLERIES_OPEN,
    itemId,
});

export const miniPDPOnDynamicGalleriesClose = () => ({
    type: MINI_PDP_ON_DYNAMIC_GALLERIES_CLOSE,
});

export const miniPDPOnStyledForYouOpen = (itemId = '') => ({
    type: MINI_PDP_ON_STYLED_FOR_YOU_OPEN,
    itemId,
});

export const miniPDPOnStyledForYouClose = () => ({
    type: MINI_PDP_ON_STYLED_FOR_YOU_CLOSE,
});

export const miniPdpAtcFromStyledForYou = (payload) => ({
    type: MINI_PDP_ATC_FROM_STYLEDFORYOU,
    payload,
});

export const miniPdpAtcFromShopTheImage = (payload) => ({
    type: MINI_PDP_ATC_FROM_SHOP_THE_IMAGE,
    payload,
});

export const miniPdpAtcFromDG = (payload) => ({
    type: MINI_PDP_ATC_FROM_DG,
    payload,
});

export const miniPDPOnShopTheImageOpen = (itemId = '') => ({
    type: MINI_PDP_ON_SHOP_THE_IMAGE_OPEN,
    itemId,
});

export const miniPDPOnShopTheImageClose = () => ({
    type: MINI_PDP_ON_SHOP_THE_IMAGE_CLOSE,
});

export const miniPDPOnShopTheLookOpen = (itemId = '') => ({
    type: MINI_PDP_ON_SHOP_THE_LOOK_OPEN,
    itemId,
});

export const miniPdpAtcFromSTL = (payload) => ({
    type: MINI_PDP_ATC_FROM_STL,
    payload,
});

export const miniPDPOnShopTheLookClose = () => ({
    type: MINI_PDP_ON_SHOP_THE_LOOK_CLOSE,
});

export const miniPDPOnShopTheSetOpen = (itemId = '') => ({
    type: MINI_PDP_ON_SHOP_THE_SET_OPEN,
    itemId,
});

export const miniPDPOnShopTheSetClose = () => ({
    type: MINI_PDP_ON_SHOP_THE_SET_CLOSE,
});

export const miniPdpAtcFromSTS = (payload) => ({
    type: MINI_PDP_ATC_FROM_STS,
    payload,
});
